const minValue = 2.5
const maxValue = 8

export { minValue, maxValue }